export type Entity = {
    entityId: string;
    entityName: 'Contacts' | 'Accounts' | 'Users' | 'Leads';
    name: string;
    avatarUrl?: string;
    initials: string;
    personName: string[];
    primaryEmailText?: string | null | undefined;
    primaryPhoneText?: string | null | undefined;
    primaryContactPhoneText?: string | null | undefined;
    primaryAddressRegion?: string | null | undefined;
    url: string[];
    primaryAccountName?: string | null | undefined;
    primaryContactName?: string | null | undefined;
    parentAccountId?: string | null | undefined;
    childAccountIds?: string[];
    description?: string | null | undefined;
    entityDescription?: string | null | undefined;
    jobTitle?: string | null | undefined;
    /** Solr: Lead::getDisplayName() */
    displayName_custom?: string | null | undefined;
    accountOrContactName?: string | null | undefined;
    marketName?: string | null | undefined;
};

export type DisplayOptionEntity = {
    id: string;
    value: any;
    type: string;
    avatarUrl: string | null | undefined;
    initials: string;
    description: string;
    secondaryInfo: any;
    tertiaryInfo?: any;
    primaryAccountName?: string | null | undefined;
    parentAccountId?: string | null | undefined;
    childAccountIds?: string[] | null | undefined;
    isDisabled?: boolean;
    disabledText?: string;
    primaryPhoneText?: string | null | undefined;
    primaryEmailText?: string | null | undefined;
    entityDescription?: string | null | undefined;
    jobTitle?: string | null | undefined;
};

function getId(entityId: string, entityName: string): string {
    return `${entityId}-${getType(entityName)}`;
}

function getType(entityName?: string | null): string {
    return entityName ? entityName.toLowerCase() : '';
}

function getDescription(entityName?: string | null): string {
    switch (entityName) {
        case 'Users':
            return 'Nutshell User';
        case 'Accounts':
            return 'Company';
        case 'Leads':
            return 'Lead';
        case 'Teams':
            return 'Team';
        case 'Contacts':
        default:
            return 'Person';
    }
}

function getSecondaryInfo(entity: Entity): string | null | undefined {
    if (entity.entityName === 'Contacts') {
        if (entity.jobTitle) {
            return entity.jobTitle;
        } else if (entity.primaryAccountName) {
            return entity.primaryAccountName;
        }
    } else if (entity.entityName === 'Leads') {
        if (entity.primaryContactName) {
            return entity.primaryContactName;
        }
        if (entity.primaryAccountName) {
            return entity.primaryAccountName;
        }
        return null;
    } else {
        return entity.personName && entity.personName.length ? entity.personName[0] : null;
    }
}

function getTertiaryInfo(entity: Entity): string | null | undefined {
    if (entity.entityName === 'Contacts') {
        if (entity.primaryEmailText) {
            return entity.primaryEmailText;
        } else if (entity.primaryPhoneText) {
            return entity.primaryPhoneText;
        }
    } else if (entity.entityName === 'Accounts') {
        if (entity.primaryAddressRegion) {
            return entity.primaryAddressRegion;
        } else if (entity.url && entity.url.length > 0) {
            return entity.url[0];
        }
    } else if (entity.entityName === 'Leads') {
        if (entity.marketName) {
            return entity.marketName;
        }
        if (entity.primaryContactPhoneText) {
            return entity.primaryContactPhoneText;
        }
    }

    return null;
}

function getMentionDisplayName(entity: Entity): string {
    if (entity.entityName !== 'Leads') {
        return entity.name;
    }
    return entity.displayName_custom || entity.accountOrContactName || entity.name || '';
}

export function mapEntityToDisplayOption(entity: Entity): any {
    const displayName = getMentionDisplayName(entity);
    return {
        id: getId(entity.entityId, entity.entityName),
        value: displayName,
        type: getType(entity.entityName),
        avatarUrl: entity.avatarUrl,
        initials: entity.initials,
        description: getDescription(entity.entityName),
        entityDescription: entity.description,
        secondaryInfo: getSecondaryInfo(entity),
        tertiaryInfo: getTertiaryInfo(entity),
        parentAccountId: entity.parentAccountId,
        childAccountIds: entity.childAccountIds || [],
        primaryPhoneText: entity.primaryPhoneText,
        primaryAccountName: entity.primaryAccountName,
        primaryEmailText: entity.primaryEmailText,
        jobTitle: entity.jobTitle,
    };
}
